module.exports = __webpack_public_path__ + "img/icon9.12486f5a.svg";